/** @format */
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';

import { DEFAULT_TEST_ID } from './constants';
import { ProductComparisonItemOutOfStockHeader as StyledProductComparisonItemOutOfStockHeader } from './out-of-stock-header.styles';
import { ProductComparisonItemOutOfStockProps } from './types';

export const ProductComparisonItemOutOfStockHeader: FunctionComponent<
    ProductComparisonItemOutOfStockProps
> = ({ 'data-testid': dataTestId = DEFAULT_TEST_ID, columnIndex }) => {
    const { t } = useTranslation();

    return (
        <StyledProductComparisonItemOutOfStockHeader
            data-testid={`${dataTestId}__header`}
            $columnIndex={columnIndex}
            $rowIndex={0}
        >
            <div className="product-comparison-item-out-of-stock-message">
                <p>
                    <strong>{t('Our stock moves fast!')}</strong>
                </p>
                <p>{t('This item is now out of stock')}</p>
            </div>
        </StyledProductComparisonItemOutOfStockHeader>
    );
};
